<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p style="text-align: center;margin-top:25px;margin-bottom:25px;"><img alt="" src="media/file1.png" style="width:3.09583in;height:2.00492in"/></p>
<p style="text-indent:00em;">The unique personalities of the English monarchy are among the most fascinating in history.</p>
<p>In this book, each monarch is given the space and time to shine and share their tribulations, tears and triumphs. Find out which overlooked Tudor became a political trailblazer, which overrated military leader would have sold London if he could find a buyer and which of our sovereigns died on the toilet.</p>
<p>It’s a thrilling tale of murder, duty, gallantry, thrift, elegance, desertion, zeal, romance, autocracy, pride, illegitimacy, riot and splendour.</p>
<p>It is impossible to understand the history of our nation without the compelling tales of our Kings and Queens. After all, the monarchy is older than the nation itself! Today, we take for granted many of their achievements, not least, the creation of a ‘United Kingdom’, the Church of England, Parliamentary Democracy and giving us all a sense of national identity.</p>
<p>It is they who we have to thank for the invention of handkerchiefs, the tradition of eating roast beef and Yorkshire puddings and even keeping goldfish as pets. This book reveals how each monarch left their mark on our lives—from the ridiculous to the sublime!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?8e55a24a